import React from "react";

function CRMDashboard({ leads, setActiveView }) {
  const totalLeads = leads.length;
  const contacted = leads.filter((lead) => lead.status === "Contacted").length;
  const auditRequested = leads.filter((lead) => lead.status === "Audit Requested").length;
  const meetings = leads.filter((lead) => lead.status === "Meeting Booked").length;
  const won = leads.filter((lead) => lead.status === "Won").length;
  const highPriority = leads.filter((lead) => lead.priority === "High").length;

  return (
    <>
      <section className="crm-hero-dashboard">
        <div>
          <span className="procrm-badge">CRM Command Centre</span>
          <h2>Lead sourcing, outreach and campaign control for ProCode ZA.</h2>
          <p>
            Manage prospects, run free 3-point digital presence audits, track follow-ups,
            and hand over interested businesses for closing.
          </p>

          <div className="procrm-hero-actions">
            <button onClick={() => setActiveView("addLead")} className="procrm-btn-primary">
              Add New Lead
            </button>
            <button onClick={() => setActiveView("leads")} className="procrm-btn-outline">
              View Pipeline
            </button>
          </div>
        </div>

        <div className="procrm-command-card">
          <div className="command-header">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <h3>Today’s Focus</h3>
          <p>
            Find businesses with real digital gaps, personalise outreach, offer the free audit,
            and track every next action.
          </p>

          <div className="command-list">
            <div>
              <strong>01</strong>
              <span>Find 20-30 new leads</span>
            </div>
            <div>
              <strong>02</strong>
              <span>Contact 20 businesses</span>
            </div>
            <div>
              <strong>03</strong>
              <span>Offer 5-10 free audits</span>
            </div>
            <div>
              <strong>04</strong>
              <span>Follow up 10 old leads</span>
            </div>
          </div>
        </div>
      </section>

      <section className="procrm-stats">
        <div className="procrm-stat-card">
          <span>Total Leads</span>
          <h2>{totalLeads}</h2>
          <p>Active prospects in CRM</p>
        </div>

        <div className="procrm-stat-card">
          <span>Contacted</span>
          <h2>{contacted}</h2>
          <p>Businesses already reached</p>
        </div>

        <div className="procrm-stat-card">
          <span>Audit Requests</span>
          <h2>{auditRequested}</h2>
          <p>Leads who requested audits</p>
        </div>

        <div className="procrm-stat-card dark">
          <span>High Priority</span>
          <h2>{highPriority}</h2>
          <p>Best-fit opportunities</p>
        </div>
      </section>

      <section className="crm-dashboard-grid">
        <div className="procrm-panel">
          <div className="panel-heading">
            <div>
              <span className="eyebrow">Pipeline Snapshot</span>
              <h2>Sales movement</h2>
            </div>
          </div>

          <div className="pipeline-bars">
            <div>
              <span>Meetings Booked</span>
              <strong>{meetings}</strong>
            </div>
            <div>
              <span>Won Deals</span>
              <strong>{won}</strong>
            </div>
            <div>
              <span>Audit Requests</span>
              <strong>{auditRequested}</strong>
            </div>
          </div>
        </div>

        <div className="procrm-panel">
          <div className="panel-heading">
            <div>
              <span className="eyebrow">Fast Actions</span>
              <h2>Jump into work</h2>
            </div>
          </div>

          <div className="quick-actions">
            <button onClick={() => setActiveView("outreach")}>Open Scripts</button>
            <button onClick={() => setActiveView("campaignBuilder")}>Build Campaign</button>
            <button onClick={() => setActiveView("agentGuide")}>Agent Guide</button>
            <button onClick={() => setActiveView("reports")}>View Reports</button>
          </div>
        </div>
      </section>
    </>
  );
}

export default CRMDashboard;